import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import { Table } from 'gdpp-components/dist/cjs/components/molecules'

import FundDividendStandalone from '../../organisms/FundDividendStandalone'
import Loader from '../../atoms/Loader'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Dropdown from '../../atoms/Dropdown'
import Modal from '../../molecules/Modal'
import FilterGenerator from '../../molecules/FilterGenerator'

import './style.scss'

const DividendRecords = ({
  id,
  allDividendData,
  dividendDropdownMenu,
  filterData,
  updateFilterData,
  monthlyDividendComparisonTable,
  dividendIntroDialogContent,
  disclaimer
}) => {
  const intl = useIntl()
  const [fundCount, setFundCount] = useState()
  const [levelCount, setLevelCount] = useState()

  useEffect(() => {
    if (allDividendData) {
      const tempFundCount = allDividendData.length
      let tempLevelCount = 0

      allDividendData.forEach((dataItem) => {
        dataItem.tableData.dataSource.forEach((sourceItem) => {
          if (sourceItem.index === 0) {
            tempLevelCount += 1
          }
        })
      })

      setFundCount(tempFundCount)
      setLevelCount(tempLevelCount)
    }
  }, [allDividendData])

  return (
    <div className="fil-fund-dividend-records" id={`fil-fund-dividend-records-${id}`}>
      <GridContainer>
        <Grid direction="grid-x" extraClasses=" align-justify fil-fund-dividend-records__header">
          <Cell extraClasses="large-6 text-left">
            <Grid>
              <Cell>
                <span id="fil-fund-dividend-records__header" className="text-heading-m">
                  <FormattedMessage id="allDividendInfo.title" />
                </span>
              </Cell>
            </Grid>
            <Grid extraClasses="fil-fund-dividend-records__modals">
              <Cell extraClasses="shrink fil-fund-dividend-records__modals-link">
                <Modal
                  {...{
                    triggerButtonConfig: {
                      label: intl.formatMessage({ id: 'allDividendInfo.dividendDateIntroLinkContent' }),
                      icon: 'calendar-3'
                    },
                    modalHeader: intl.formatMessage({ id: 'allDividendInfo.dividendDateIntroLinkContent' }),
                    modalHeaderClasses: 'text-left',
                    size: 'small',
                    dialogContent: dividendIntroDialogContent,
                    zIndex: 100
                  }}
                />
                <Modal
                  {...{
                    triggerButtonConfig: {
                      label: intl.formatMessage({ id: 'allDividendInfo.monthlyDividendComparisonLinkContent' }),
                      icon: 'notes-checklist-flip'
                    },
                    modalHeader: intl.formatMessage({ id: 'allDividendInfo.monthlyDividendComparisonLinkContent' }),
                    modalHeaderClasses: 'text-left',
                    zIndex: 100
                  }}
                >
                  {monthlyDividendComparisonTable && (
                    <Table
                      tableId="dividend-date-intro-modal"
                      {...{
                        extraClasses: monthlyDividendComparisonTable.extraClasses,
                        ...monthlyDividendComparisonTable.tableData
                      }}
                      isAutoFitWidth
                    />
                  )}
                </Modal>
              </Cell>
            </Grid>
          </Cell>
          <Cell extraClasses="large-6 text-right show-for-large">
            <Dropdown
              {...{
                id: `fil-fund-dividend-records-dropdown-large`,
                type: 'dropdown',
                alignment: 'right',
                size: 'standard',
                icon: ['custom-chevron-up', 'custom-chevron-down'],
                label: intl.formatMessage({ id: 'allDividendInfo.dividendDropdownTitle' }),
                kind: 'tertiary',
                extraClasses: 'fil-fund-table--row-action-pdf',
                menu: dividendDropdownMenu
              }}
            />
          </Cell>
          <Cell extraClasses="large-6 text-right hide-for-large">
            <Dropdown
              {...{
                id: `fil-fund-dividend-records-dropdown-small`,
                type: 'dropdown',
                alignment: 'right',
                icon: ['custom-chevron-up', 'custom-chevron-down'],
                label: intl.formatMessage({ id: 'allDividendInfo.dividendDropdownTitle' }),
                kind: 'tertiary',
                extraClasses: 'fil-fund-table--row-action-pdf full-width',
                menu: dividendDropdownMenu
              }}
            />
          </Cell>
        </Grid>
        {allDividendData ? (
          <React.Fragment>
            {!isEmpty(filterData) && (
              <FilterGenerator filterData={filterData.blocks[0]} common={filterData.common} updateFilterData={updateFilterData} />
            )}
            <Grid direction="grid-x">
              <Cell extraClasses="small-12 fil-fund-dividend-records__tables">
                <div id="fil-fund-dividend-records__total-result" className="fil-fund-dividend-records__tables-total-result text-left">
                  <FormattedMessage
                    id="allDividendInfo.fundsResult"
                    values={{
                      fundCount,
                      levelCount
                    }}
                  />
                </div>
                <div id="fil-fund-dividend-records__tables-list" className="fil-fund-dividend-records__tables-list">
                  {allDividendData.length !== 0 ? (
                    <FundDividendStandalone fundDividendStandaloneTable={allDividendData} />
                  ) : (
                    <div className="fil-fund-dividend-records__tables-list-no-result">
                      <FormattedMessage id="allDividendInfo.noResult" />
                    </div>
                  )}
                </div>
              </Cell>
              <Cell
                id="fil-fund-dividend-records__disclaimer"
                extraClasses="small-12 fil-fund-dividend-records__disclaimer text-left text-body-xs"
              >
                {typeof disclaimer === 'string' ? <div dangerouslySetInnerHTML={{ __html: disclaimer }} /> : disclaimer}
              </Cell>
            </Grid>
          </React.Fragment>
        ) : (
          <Loader />
        )}
      </GridContainer>
    </div>
  )
}

DividendRecords.propTypes = {
  id: PropTypes.string.isRequired,
  allDividendData: PropTypes.array,
  dividendDropdownMenu: PropTypes.array,
  monthlyDividendComparisonTable: PropTypes.object,
  dividendIntroDialogContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  filterData: PropTypes.object,
  updateFilterData: PropTypes.func,
  disclaimer: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
}

DividendRecords.defaultProps = {
  allDividendData: null,
  dividendDropdownMenu: [],
  monthlyDividendComparisonTable: null,
  dividendIntroDialogContent: '',
  filterData: {},
  updateFilterData: () => {},
  disclaimer: ''
}

export default DividendRecords
